import React from "react";
import { getQuery } from '../utils/browser';
import { getData } from "../utils/api"
import './App.css';

const model = getQuery('model');
const locale = getQuery("locale") || 'zh_cn'
const SOURCE_PATH = 'https://cnbj1.fds.api.xiaomi.com'
export default class App extends React.Component {

    constructor(props){
        super(props)
        this.state = {
            config:undefined
        }
    }

    componentDidMount(){
        document.title = '使用指南'
        getData(`/user-guide-video/${model}/${locale}/index.json`).then(res=>{
            this.setState({ config: res })
            document.title = res.title
        }).catch(error=>{
            console.log('error',error)
        })
    }

    renderConfig = () =>{
        const { title_img, video, video_img, img_list } = this.state.config
        return(
            <div>
                <div className="img_box">
                    <img src={`${SOURCE_PATH}/${title_img}`} />
                </div>
                <div className="img_box">
                    <video loop="loop" preload="auto" webkit-playsinline="true" playsinline="true" controls="controls" src={`${SOURCE_PATH}/${video}`} poster={`${SOURCE_PATH}/${video_img}`} />
                </div>
                {
                    img_list.map((item,index) => {
                        return(
                            <div className="img_box" key={index}>
                                <img src={`${SOURCE_PATH}/${item.img}`} />
                            </div>
                        )
                    })
                }
            </div>

        )
    }

    render(){
        return(
            <>
                {this.state.config ? this.renderConfig() : null}
            </>
        )
    }
}